<!-- Формульный ввод массы брутто груза заказа с расчётом от веса одного места. -->
<template>
  <BaseInlineFormula
    :fields="3"
    :separators="['×', '=']"
    :sizes="['md', 'lg', 'xl']"
  >
    <template #field-0>
      <base-label
        :required="true"
        :filled="Boolean(item.quantity)"
      >
        Количество мест
      </base-label>
      <base-input
        :model-value="item.quantity"
        type="big_number"
        min="0"
        step="1"
        placeholder="0"
        :invalid="Boolean(errors[errorKey('quantity')])"
        @update:modelValue="updateField('quantity', $event)"
      />
      <span
        v-if="errors[errorKey('quantity')]"
        class="error-message"
      >
        Укажите количество мест
      </span>
    </template>

    <template #field-1>
      <base-label>Вес одного места, кг</base-label>
      <base-input
        :model-value="item.weight_kg"
        type="big_number"
        min="0"
        step="0.001"
        placeholder="0.000"
        @update:modelValue="updateField('weight_kg', $event)"
      />
    </template>

    <template #field-2>
      <base-label
        :required="true"
        :filled="Boolean(item.gross_weight_kg)"
      >
        Масса брутто, кг
      </base-label>
      <base-input
        :model-value="item.gross_weight_kg"
        type="big_number"
        min="0"
        step="0.001"
        placeholder="0.000"
        :invalid="Boolean(errors[errorKey('gross_weight_kg')])"
        @update:modelValue="updateField('gross_weight_kg', $event)"
      />
      <span
        v-if="errors[errorKey('gross_weight_kg')]"
        class="error-message"
      >
        Укажите массу брутто
      </span>
    </template>
  </BaseInlineFormula>
</template>

<script>
export default {
  name: "CargoWeightFormula",

  props: {
    errors: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  emits: ["update-field"],

  methods: {
    updateField(field, value) {
      this.$emit("update-field", { index: this.index, field, value });
    },

    errorKey(field) {
      return `cargoItems.${this.index}.${field}`;
    },
  },
};
</script>
